import axios from 'axios';

let inFlightServerSettingsRequest: Promise<any[] | null> | null = null;
let cachedServerSettings: any[] | null = null;
let cachedServerUrl = '';
let cacheExpiresAt = 0;

const SETTINGS_CACHE_TTL_MS = 5000;

export const clearServerSettingsCache = () => {
  inFlightServerSettingsRequest = null;
  cachedServerSettings = null;
  cachedServerUrl = '';
  cacheExpiresAt = 0;
};

export const fetchServerSettings = async (
  serverUrl: string | undefined,
  accessToken: string | null,
  languageId: string | null
): Promise<any[] | null> => {
  if (!serverUrl || !accessToken) {
    return null;
  }

  const now = Date.now();

  if (
    cachedServerSettings &&
    cachedServerUrl === serverUrl &&
    now < cacheExpiresAt
  ) {
    return cachedServerSettings;
  }

  if (inFlightServerSettingsRequest) {
    return inFlightServerSettingsRequest;
  }

  const headers = { Authorization: `Bearer ${accessToken}`, Language: languageId };

  inFlightServerSettingsRequest = axios
    .get(`${serverUrl}/settings/Server`, { headers })
    .then((res) => {
      const settings = res?.data?.data ?? [];
      cachedServerSettings = settings;
      cachedServerUrl = serverUrl;
      cacheExpiresAt = Date.now() + SETTINGS_CACHE_TTL_MS;
      return settings;
    })
    .catch(() => null)
    .finally(() => {
      inFlightServerSettingsRequest = null;
    });

  return inFlightServerSettingsRequest;
};
